import axios from "../../../api/axiosInstance";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  refresh_token: string;
}

export interface RefreshAuthTokenResponse {
  token: string;
  refresh_token: string;
}

export const login = async (
  requestData: LoginRequest,
): Promise<LoginResponse> => {
  const response = await axios.post<LoginResponse>(
    "/api/login_check",
    requestData,
  );
  return response.data;
};

export const refreshAuthToken = async (
  refreshToken: string,
): Promise<RefreshAuthTokenResponse> => {
  const response = await axios.post<RefreshAuthTokenResponse>(
    "/api/token/refresh",
    { refresh_token: refreshToken },
  );
  return response.data;
};
